"use client";

import React from "react";
import { motion } from "framer-motion";
import { IOS_PUSH } from "@/src/shared/constants/animation";
import {
  type IPaymentGatewayChoice,
  PaymentMethodList,
  SaveBkashCheckbox,
} from "@/src/shared/features/payment";
import ConfirmPayPrimaryButton from "@/src/features/listing/components/ConfirmPay/ConfirmPayPrimaryButton";
import ConfirmPayTopBar from "@/src/features/listing/components/ConfirmPay/ConfirmPayTopBar";

interface ISelectPaymentMethodPageProps {
  choice: IPaymentGatewayChoice;
  isPaying: boolean;
  onPay: () => void;
  onBack: () => void;
}

/** The app's `SelectPaymentMethodPage`: the method list, the save box, then Pay Now. */
const SelectPaymentMethodPage: React.FC<ISelectPaymentMethodPageProps> = ({
  choice,
  isPaying,
  onPay,
  onBack,
}) => (
  <motion.div
    initial={{ x: "100%" }}
    animate={{ x: 0 }}
    exit={{ x: "100%" }}
    transition={IOS_PUSH}
    role="dialog"
    aria-modal
    aria-label="Select a payment method"
    className="fixed inset-0 z-50 flex flex-col bg-white pt-[env(safe-area-inset-top)] md:hidden"
  >
    <div className="scrollbar-hide min-h-0 flex-1 overflow-y-auto overscroll-contain pt-4">
      <ConfirmPayTopBar title="Select a payment method" onBack={onBack} />
      <div className="mx-4 mt-6">
        <PaymentMethodList choice={choice} />
      </div>
    </div>
    <div className="px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-4">
      <SaveBkashCheckbox choice={choice} className="mb-4" />
      <ConfirmPayPrimaryButton
        label="Pay Now"
        isLoading={isPaying}
        onClick={onPay}
      />
    </div>
  </motion.div>
);

export default SelectPaymentMethodPage;
